import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import '../../stylings/video.css'

const VideoGallery = () => {
  const { videoGallery } = useSelector((state) => state.videoGallery)
  const [activeVideo, setActiveVideo] = useState(null)

  const embedUrl = (url) =>
    url.replace('https://youtu.be/', 'https://www.youtube.com/embed/')
       .replace('https://youtu.be', 'https://www.youtube.com/embed')

  const thumbUrl = (url) => {
    const id = url.split('/').pop().split('?')[0]
    return 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg'
  }

  const hasVideos = videoGallery.length > 0

  return (
    <section className="video-gallery-section">
      <div className="container">

        {/* ── Section header ── */}
        <div className="vg-section-header">
          <div className="vg-section-header-left">
            <div className="vg-section-tag">
              <i className="fa-brands fa-youtube"></i>
              Video Gallery
            </div>
            <h2 className="vg-section-title">Watch &amp; Explore</h2>
            <p className="vg-section-subtitle">
              School events, performances and highlights — all in one place.
            </p>
          </div>
          <Link to="/videoall" className="vg-view-all-btn">
            View All Videos <i className="fa-solid fa-arrow-right"></i>
          </Link>
        </div>

        {/* ── Video Grid ── */}
        {hasVideos ? (
          <div className="vg-grid-scroll-wrap">
            <div className="vg-grid">
            {videoGallery.map((item, idx) => (
              item.attachments.map((att, ai) => ai < 1 && (
                <div key={item.id} className="vg-card">
                  {activeVideo === item.id ? (
                    <div className="vg-iframe-wrap">
                      <iframe
                        src={embedUrl(att.path) + '?autoplay=1&rel=0'}
                        title={item.eventname || 'School Video ' + (idx + 1)}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  ) : (
                    <div
                      className="vg-thumb"
                      onClick={() => setActiveVideo(item.id)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => e.key === 'Enter' && setActiveVideo(item.id)}
                      aria-label={"Play " + (item.eventname || 'video')}
                    >
                      <img
                        src={thumbUrl(att.path)}
                        alt={item.eventname || 'School Video'}
                        className="vg-thumb-img"
                        onError={(e) => { e.target.style.display = 'none' }}
                      />
                      <div className="vg-play-overlay">
                        <div className="vg-play-btn">
                          <i className="fa-solid fa-play"></i>
                        </div>
                      </div>
                      {item.eventname && (
                        <div className="vg-thumb-label">
                          <i className="fa-solid fa-film"></i>
                          {item.eventname}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))
            ))}
            </div>
          </div>
        ) : (
          <div className="vg-empty">
            <i className="fa-brands fa-youtube"></i>
            <p>No videos available yet. Check back soon!</p>
          </div>
        )}

      </div>
    </section>
  )
}

export default VideoGallery
